import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { UserComponent } from './user.component';
import { MatIconModule } from '@angular/material/icon';
import { UiAvatarImageComponent } from '../../shared/libs/up-header/ui-avatar/ui-avatar-image.component';
import { UpTopHeaderComponent } from '../../shared/libs/up-header/up-top-header/up-top-header.component';
import { CompanySelectionComponent } from './components/company-selection/company-selection.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { SharedModule } from 'src/app/shared/shared.module';
import { LoginComponent } from './components/login/login.component';
import { UserRouting } from './user.routing';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    UserRouting,
    MatIconModule,
    UiAvatarImageComponent,
    UpTopHeaderComponent,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    SharedModule
  ],
  declarations: [
    UserComponent,
    LoginComponent,
    CompanySelectionComponent
  ],
  exports: [UserComponent],
  providers: []
})
export class UserModule {}
